import { render, staticRenderFns } from "./lay-out-head.vue?vue&type=template&id=2228db5e&scoped=true"
import script from "./lay-out-head.vue?vue&type=script&lang=js"
export * from "./lay-out-head.vue?vue&type=script&lang=js"
import style0 from "./lay-out-head.vue?vue&type=style&index=0&id=2228db5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2228db5e",
  null
  
)

export default component.exports